var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"!w-[220px]",attrs:{"searchable":false,"placeholder":"Filter","reduce":val => val.id,"label":"name","options":_vm.filters},model:{value:(_vm.queryFilters.filter),callback:function ($$v) {_vm.$set(_vm.queryFilters, "filter", $$v)},expression:"queryFilters.filter"}})
}
var staticRenderFns = []

export { render, staticRenderFns }